import { useState } from "react";

interface WindowStyle {
  id: string;
  name: string;
  tagline: string;
  desc: string;
  features: string[];
  upvc: boolean;
  aluminium: boolean;
  image: string;
  from: string;
  popularFor: string;
}

interface WindowTypeCardProps {
  window: WindowStyle;
  onQuote: (name: string) => void;
}

export default function WindowTypeCard({ window: w, onQuote }: WindowTypeCardProps) {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      className="bg-white rounded-lg border border-stone-100 overflow-hidden hover:border-amber-300 transition-all duration-300 flex flex-col"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div className="w-full h-52 overflow-hidden relative">
        <img
          src={w.image}
          alt={`${w.name} Surrey`}
          className={`w-full h-full object-cover object-top transition-transform duration-500 ${hovered ? "scale-105" : "scale-100"}`}
        />
        <div className="absolute top-3 left-3 flex gap-2">
          {w.upvc && (
            <span className="bg-stone-800/80 text-white text-[10px] font-bold px-2 py-1 rounded-full tracking-wide" style={{ fontFamily: "'Raleway', sans-serif" }}>
              uPVC
            </span>
          )}
          {w.aluminium && (
            <span className="bg-amber-600/90 text-white text-[10px] font-bold px-2 py-1 rounded-full tracking-wide" style={{ fontFamily: "'Raleway', sans-serif" }}>
              Aluminium
            </span>
          )}
        </div>
        <div className="absolute bottom-3 right-3 bg-white/95 rounded-md px-3 py-1">
          <span className="text-zinc-400 text-[10px]" style={{ fontFamily: "'Raleway', sans-serif" }}>from </span>
          <span className="text-amber-600 text-sm font-bold" style={{ fontFamily: "'Raleway', sans-serif" }}>{w.from}</span>
        </div>
      </div>
      <div className="p-5 flex flex-col flex-1">
        <p className="text-amber-600 text-[10px] font-bold tracking-widest uppercase mb-1" style={{ fontFamily: "'Raleway', sans-serif" }}>
          {w.tagline}
        </p>
        <h3 className="text-lg font-bold text-zinc-800 mb-2" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
          {w.name}
        </h3>
        <p className="text-zinc-500 text-xs leading-relaxed mb-4" style={{ fontFamily: "'Raleway', sans-serif" }}>
          {w.desc}
        </p>
        <div className="space-y-1.5 mb-4">
          {w.features.map((f) => (
            <div key={f} className="flex items-center gap-2">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-checkbox-circle-line text-amber-500 text-sm"></i>
              </div>
              <span className="text-zinc-600 text-xs" style={{ fontFamily: "'Raleway', sans-serif" }}>{f}</span>
            </div>
          ))}
        </div>
        <div className="mt-auto pt-4 border-t border-stone-100 flex items-center justify-between">
          <div>
            <p className="text-zinc-400 text-[10px] uppercase tracking-wide" style={{ fontFamily: "'Raleway', sans-serif" }}>Popular for</p>
            <p className="text-zinc-600 text-xs font-medium" style={{ fontFamily: "'Raleway', sans-serif" }}>{w.popularFor}</p>
          </div>
          <button
            onClick={() => onQuote(w.name)}
            className="bg-amber-600 hover:bg-amber-500 text-white text-xs font-semibold px-4 py-2 rounded-md transition-colors whitespace-nowrap cursor-pointer"
            style={{ fontFamily: "'Raleway', sans-serif" }}
          >
            Get Quote
          </button>
        </div>
      </div>
    </div>
  );
}
